export { default } from './docs.js';
